<template>
  <div class="concerts">
    <div
      class="loading-container no-scroll"
      v-if="isLoading || (this.sortedTracks.length === 0 && !showError)"
    >
      <img src="/loader.svg" height="400" width="300" />
    </div>
    <!-- <p v-if="sortedTracks.length === 0 && !isLoading">
      We couldn't find any concerts in your area. Try dragging the map or
      inputting a different location.
    </p>-->
    <TypeAhead
      :fetchUrl="typeaheadUrl"
      :typeaheadBaseLink="typeaheadBaseLink"
      :inputedLocation="inputedLocation"
      :lat="lat"
      :lng="lng"
      @fetchForLink="callFetchConcerts"
    >
      <input
        type="text"
        placeholder="Type Your Location"
        v-model="inputedLocation"
        @keyup.enter="callFetchInputedTracks"
        @keyup="setTypeaheadUrl"
      />
      <button @click="callFetchInputedTracks">Find Music!</button>
    </TypeAhead>
    <div class="toggle-container">
      <div class="toggle-buttons">
        <button
          class="toggle no-styles"
          :class="{ active: showEvents }"
          @click="toggleProperty(showEvents, 'showEvents')"
        >
          <span class="icon-calendar"></span>
        </button>
        <button
          class="toggle no-styles"
          :class="{ active: showSettings }"
          @click="toggleProperty(showSettings, 'showSettings')"
        >
          <span class="iconequalizer12 boxypl"></span>
        </button>
      </div>
    </div>
    <transition name="fade-in-scale">
      <Modal
        @closeModal="closeModal"
        :isModalOpen="isModalOpen"
        v-if="isModalOpen"
      >
        <a :href="modalEvent.url" target="_blank">
          {{ modalEvent.name }}
        </a>
        on {{ modalEvent.date }}
        <EventsMap
          :lat="modalEvent.location.geo.latitude"
          :lng="modalEvent.location.geo.longitude"
          :modalEvent="modalEvent"
          zoom="17"
        />
      </Modal>
    </transition>

    <section class="map">
      <MusicMap
        v-if="sortedTracks.length > 0"
        :geolocation="geolocation"
        :markers="mapMarkers"
        v-bind="{ lat, lng, city }"
        zoom="8"
        @fetchData="callFetchConcerts"
      />
    </section>
    <transition name="scroll">
      <div id="playlist" v-if="!showMap && !isLoading">
        <div v-if="showError">
          No songs available with the parameters you added.
        </div>
        <div class="exact-location">
          <span class="icontarget"></span>
          {{ city }}
        </div>
        <SpotifyButton
          v-if="sortedTracks.length > 0"
          :tracks="sortedTracks"
          :showPlayer="showPlayer"
          @toggleProperty="toggleProperty"
          :name="
            `Artists playing near ${city} between ${cDate} and ${fDate} MWYA`
          "
        />
        <ul v-if="!isLoading" class="cards">
          <MusicCard
            v-for="(a, index) in sortedTracks"
            :track="a"
            :name="a.name"
            :artists="a.artists"
            :id="a.id"
            :key="a.idindex"
            :index="index"
            :event="a.event"
            @remove="remove"
            @getInfo="getInfo"
            @openMapModal="openMapModal"
          />
        </ul>
      </div>
    </transition>
    <transition name="scroll">
      <div v-if="isLoading">
        <img src="/loader.svg" height="400" width="300" />
      </div>
      <section
        v-if="showEvents"
        class="events"
        v-infinite:callback="{
          fn: this.fetchConcerts,
          nestedEl: '.card',
          numPerRow: 5
        }"
      >
        <h2>
          Concerts from {{ cDate }} to {{ fDate }} in and around {{ city }}
        </h2>
        <ul>
          <li v-for="(evt, index) in events" :key="evt.name">
            <div>
              <a v-bind:href="evt.url" target="_blank">{{ evt.name }}</a>
            </div>
            <div>{{ evt.startDate }}</div>
            <div>
              {{ evt.location.address.streetAddress }}<br />
              {{ evt.location.address.addressLocality }},
              {{ evt.location.address.addressRegion }}
              {{ evt.location.address.addressCountry }}
              {{ evt.location.address.postalCode }}
            </div>
            <br />
          </li>
        </ul>
      </section>
    </transition>
    <transition name="scroll-from-top">
      <section id="info" v-if="showArtistEvents">
        <GeneralInfo
          :artist="artist"
          :propertyToToggle="showArtistEvents"
          :dataUrls="dataUrls"
          @toggleInfoIsResolved="toggleInfoIsResolved"
        >
          <template v-if="infoIsResolved" v-slot:default="slotProps">
            <div>
              <header>
                <h2>{{ slotProps.data.bio.artist.name }}</h2>
              </header>
              <div class="container">
                <section class="static-content">
                  <div class="image-bio">
                    <div
                      class="info-image-container"
                      v-if="
                        slotProps.data &&
                          slotProps.data.bio &&
                          slotProps.data.artist
                      "
                    >
                      <img
                        v-if="
                          slotProps.data &&
                            slotProps.data.bio.artist &&
                            slotProps.data.artist.images.length &&
                            slotProps.data.artist.images[0].url
                        "
                        :src="slotProps.data.artist.images[2].url"
                        :alt="slotProps.data.bio.artist.name"
                      />
                    </div>
                    <div
                      class="info-bio"
                      v-if="slotProps.data && slotProps.data.bio.artist.bio"
                    >
                      <p v-html="slotProps.data.bio.artist.bio.summary"></p>
                    </div>
                  </div>
                  <div class="info-related">
                    <h4>Related Artists</h4>
                    <ul v-if="slotProps.data && slotProps.data.related.artists">
                      <li
                        class="related-artist-list-item"
                        v-for="r in slotProps.data.related.artists"
                        @click="slotProps.fetchData(r.name)"
                        :key="r.id"
                      >
                        <button
                          @click="getRelatedInfo(r)"
                          class="info-related-item"
                        >
                          <img
                            v-if="r.images[2]"
                            :src="r.images[2].url"
                            :alt="r.name"
                            height="160"
                            width="160"
                          />
                          <div>{{ r.name }}</div>
                        </button>
                      </li>
                    </ul>
                  </div>
                </section>
                <section class="media-content">
                  <SpotifyButton
                    v-if="
                      slotProps.data &&
                        slotProps.data.topTracks &&
                        slotProps.data.topTracks.tracks.length
                    "
                    :tracks="slotProps.data.topTracks.tracks"
                    :showPlayer="showInfoPlayer"
                    :property="'showInfoPlayer'"
                    @toggleProperty="toggleProperty"
                    :name="
                      `Top Tracks by ${
                        slotProps.data.topTracks.tracks[0].artists[0].name
                      } from MWYA `
                    "
                  />
                  <ul
                    v-if="
                      slotProps.data &&
                        slotProps.data.topTracks &&
                        slotProps.data.topTracks.tracks.length
                    "
                    class="top-tracks-list"
                  >
                    <li
                      class="top-tracks-item"
                      v-for="tt in slotProps.data.topTracks.tracks"
                      :key="tt.id"
                    >
                      <div>
                        <a
                          :href="'https://open.spotify.com/track/' + tt.id"
                          target="_blank"
                          >{{ tt.name }}</a
                        >
                      </div>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
            <transition name="fade-enter">
              <footer class="info-footer">
                <div class="icon-container">
                  <button class="iconarrow-up" @click="closeInfo()"></button>
                </div>
              </footer>
            </transition>
          </template>
        </GeneralInfo>
      </section>
    </transition>
    <transition name="scroll-half">
      <div id="genres" v-if="showSettings">
        <!-- <div class="dates">
          <input
            type="date"
            v-model="currentDate"
            @keyup.enter="callFetchInputedTracks"
          />
          <input
            type="date"
            v-model="futureDate"
            @click="callFetchInputedTracks"
          />
          <button @click="callFetchConcerts">Submit</button>
        </div> -->
        <legend>Available Genres</legend>
        <fieldset>
          <div
            class="checkbox"
            v-for="(icon, index) in genreIcons"
            :key="icon.genre.genre"
          >
            <!-- <router-link
              :to="
                selectedGenres && selectedGenres.length
                  ? `/concerts/${lat},${lng}/${icon.genre.genre}`
                  : `/concerts/${lat},${lng}/`
              "
            > -->
            <input
              :checked="icon.genre.checkedState"
              type="checkbox"
              class="check"
            />
            <label
              :for="icon.genre.genre"
              :class="{ on: icon.genre.checkedState }"
              @click="setGenre(icon)"
            >
              <div :class="icon.genre.genre"></div>
              <div class="genre_text">{{ icon.genre.name }}</div>
            </label>
            <!-- </router-link> -->
          </div>
        </fieldset>
      </div>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import TypeAhead from "@/components/TypeAhead.vue";
import MusicCard from "@/components/MusicCard.vue";
import MusicMap from "@/components/MusicMap.vue";
import GeneralInfo from "@/components/GeneralInfo.vue";
import Modal from "@/components/Modal.vue";
import EventsMap from "@/components/EventsMap.vue";
import SpotifyButton, { auth_header } from "@/components/SpotifyButton.vue";
import axios from "axios";
import { getGeolocation } from "@/utils/geolocation";
import {
  sortArrAsc,
  sortClosest,
  flattenArrayOfObjects,
  getAllIndices,
  removeDuplicatesArrObj
} from "@/utils/arrays";
import { memoize } from "@/utils/memoize";
import {
  getGenres,
  getCheckedGenres,
  getGenre,
  clearGenres,
  toggleGenre,
  getGenreTitles
} from "@/icons/genre-icons";
import { getSpotifyToken } from "@/utils/spotify-token";

const isLocalHost = window.location.origin.indexOf("localhost") > -1;
const baseUrl = isLocalHost
  ? "https://localhost:3000/"
  : "https://api.musicwhereyouare.com/";
// const baseUrl = "https://api.musicwhereyouare.com/";
const today = new Date();
const dd =
  today.getDate().toString().length === 1
    ? `0${today.getDate()}`
    : today.getDate();
const mm =
  (today.getMonth() + 1).toString().length === 1
    ? `0${today.getMonth() + 1}`
    : today.getMonth() + 1;
const year = today.getFullYear();
const future = new Date();
future.setDate(future.getDate() + 14);
const fdd =
  future.getDate().toString().length === 1
    ? `0${future.getDate()}`
    : future.getDate();
const fmm =
  (future.getMonth() + 1).toString().length === 1
    ? `0${future.getMonth() + 1}`
    : future.getMonth() + 1;
const fyear = future.getFullYear();
const pattern = /\W@[\w\d \W]*|\W\bat\b[\w\d \W]*|\W\bin\b[\w\d \W]*|\W\bon\b[\w\d \W]*|\W\blive\b[\w\d \W]*|\W\concert\b[\w\d \W]*/gi;

export default {
  name: "concerts",
  components: {
    EventsMap,
    Modal,
    MusicCard,
    MusicMap,
    GeneralInfo,
    SpotifyButton,
    TypeAhead
  },
  data() {
    return {
      artists: [],
      topTracks: [],
      city: "",
      showSummary: true,
      geolocation: {},
      sortedTracks: [],
      inputedLocation: "",
      isModalOpen: false,
      lat_lng: "",
      lat: 0,
      lng: 0,
      modalLat: 0,
      modalLng: 0,
      mapMarkers: [],
      showMap: false,
      showPlayer: false,
      showInfoPlayer: false,
      showArtistEvents: false,
      showSettings: false,
      showEvents: false,
      isLoading: false,
      events: [],
      eventsPage: 0,
      tracksPage: 0,
      tracksLimit: 100,
      genreIcons: getGenres(),
      genreForTitle: "",
      genres: [],
      dataUrls: {},
      fDate: `${fmm}-${fdd}-${fyear}`,
      cDate: `${mm}-${dd}-${year}`,
      currentDate: `${year}-${mm}-${dd}`,
      futureDate: `${fyear}-${fmm}-${fdd}`,
      cityList: [],
      typeaheadUrl: "",
      typeaheadBaseLink: "/concerts/",
      totalEvents: 0,
      showError: false,
      selectedGenres: "",
      infoIsResolved: false
    };
  },

  mounted: function() {
    this.selectedGenres = this.$route.params.genres;
    if (this.selectedGenres) {
      const genre = this.selectedGenres
        .split("*")
        .map(genre => getGenre(genre));
      this.setGenre(genre[0][0]);
      return;
    }
    const lat_lng = this.$route.params.lat_lng || sessionStorage.hash || "";
    if (lat_lng.length > 0) {
      const latLng = lat_lng.split(",");
      if (parseInt(latLng[0].trim())) {
        const lat = latLng[0].trim();
        const lng = latLng[1].trim();
        this.fetchConcerts(lat, lng);
      } else {
        const lat = lat_lng.split(",")[0];
        const lng = lat_lng.split(",")[1];
        this.fetchInputedTracks(lat, lng);
      }
    } else {
      getGeolocation().then(data => {
        this.geolocation = data;
        const lat = data.latitude;
        const lng = data.longitude;

        this.fetchConcerts(lat, lng);
      });
    }
  },
  methods: {
    // allow this to get called via an infinite scroll
    async fetchConcerts(lat, lng, page) {
      const geolocationUrl = `${baseUrl}geolocationMultiple/and~Lat:${lat}_Lng:${lng}?limit=20 `;
      const geolocationData = await memoize(geolocationUrl, axios.get, [
        geolocationUrl
      ]);

      const massagedGeoData = geolocationData.data
        .map(item => {
          item.Lat =
            item.Lat && item.Lat.$numberDecimal
              ? item.Lat.$numberDecimal
              : item.Lat;
          item.Lng =
            item.Lng && item.Lng.$numberDecimal
              ? item.Lng.$numberDecimal
              : item.Lng;
          return item;
        })
        .filter(item => item.CityName !== "-");
      const usableGeolocation = sortClosest(
        massagedGeoData,
        ["Lat", "Lng"],
        [lat, lng]
      );
      // this should be made into a util
      const isUS = geolocationData.data[0].CountryID === "US";
      const isCanada = geolocationData.data[0].CountryID === "CA";
      const isGreatBritain = geolocationData.data[0].CountryID === "GB";
      const isAustrailia = geolocationData.data[0].CountryID === "AU";
      if (isGreatBritain) {
        geolocationData.data[0].CountryID === "UK";
      }
      const citieParts = usableGeolocation[0].item.City.split(" ");
      const city = citieParts
        .map(city => {
          return `${city.charAt(0).toUpperCase()}${city
            .substr(1)
            .toLowerCase()}`;
        })
        .join(" ");
      const regionParts = usableGeolocation[0].item.Region.split(" ");
      const region = regionParts
        .map(region => {
          return `${region.charAt(0).toUpperCase()}${region
            .substr(1)
            .toLowerCase()}`;
        })
        .join(" ");
      const countryParts = usableGeolocation[0].item.Country.split(" ");
      const country = countryParts.map(country => {
        return `${country.charAt(0).toUpperCase()}${country
          .substr(1)
          .toLowerCase()}`;
      });
      if (isUS) {
        this.city = `${city}, ${region}, ${
          usableGeolocation[0].item.CountryID
        }`;
      } else if (isCanada) {
        this.city = `${city}, ${country}`;
      } else if (isGreatBritain) {
        this.city = `${city}, UK`;
      } else if (isAustrailia) {
        this.city = `${city}, ${usableGeolocation[0].item.CountryID}`;
      } else {
        this.city = `${city}, ${region}, ${country}`;
      }
      this.artists = [];
      this.isLoading = this.showEvents ? false : true;
      const router = this.$router;
      if (!lat || !lng) {
        this.lat_lng = router.currentRoute.params.lat_lng;
        lat = this.lat_lng.split(",")[0];
        lng = this.lat_lng.split(",")[1];
      } else {
        this.lat_lng = `${lat},${lng}`;
      }
      if (!router.currentRoute.params.lat_lng) {
        router.push(this.lat_lng);
      }

      sessionStorage.hash =
        router.currentRoute.path.indexOf("concerts/") === -1
          ? this.lat_lng
          : this.genres
          ? `concerts/${this.lat_lng}/${this.genres}`
          : `concerts/${this.lat_lng}`;
      this.eventsPage = page ? page : this.eventsPage + 1;
      // set up memoizing to cache playlists
      const numOfEvents = 50;
      const eventsUrl = `${baseUrl}eventsForLocation/${
        this.city
      }?num_of_events=${numOfEvents}`;
      return memoize(eventsUrl, axios.get, [eventsUrl])
        .then(res => {
          if (res.data[0] === "undefined" || res.data.name === "TimeoutError") {
            this.showError = true;
            this.isLoading = false;
            return;
          }
          const events = res.data.map(d => {
            d.date = formatDate(d.startDate);
            return d;
          });
          this.events = this.events.concat(events.filter(evt => evt.performer));
          const performers = this.events
            .filter(evt => evt.performer)
            .map(evt => {
              return evt.performer.map(perf => {
                return {
                  name: perf.name,
                  event: evt
                };
              });
            });
          this.artists = performers;
          this.totalEvents = numOfEvents;
          this.fetchTopTracks();
          return res;
        })
        .catch(e => {
          this.eventsPage = 0;
          this.events = [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    fetchTopTracks() {
      this.showError = false;
      this.isLoading = this.showEvents ? false : true;
      const lat_lng = this.$route.params.lat_lng;
      const lat = lat_lng.split(",")[0];
      const lng = lat_lng.split(",")[1];
      const iterator = 100;
      this.tracksPage =
        this.eventsPage - 1 >= 1 ? this.eventsPage * iterator : 1;
      this.tracksLimit = this.tracksPage + iterator;
      const promises = this.artists.map(artist => {
        if (!artist || artist.length === 0) {
          return;
        }
        const artistName = artist[0].name;
        const normalizedArtist = artistName
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(pattern, "");

        const baseUrl =
          "https://api.spotify.com/v1/search?type=track&q=artist:";
        const url = this.genres.length
          ? `${baseUrl}${normalizedArtist} AND ${encodeURIComponent(
              this.genres
            )}&limit=25&market=US&type=track`
          : `${baseUrl}${normalizedArtist}&limit=15&market=US&type=track`;
        return memoize(encodeURIComponent(url), fetch, [url, "GET"], {
          headers: auth_header
        }).then(data => {
          return data.clone().json();
        });
      });
      return Promise.allSettled(promises)
        .then(data => {
          if (data[0].value && data[0].value.error) {
            return;
          }
          if (data[0].value.status === 401) {
            sessionStorage.removeItem("accessToken");
            getSpotifyToken();
          }
          let tracks = [];
          data.forEach((d, index) => {
            if (d && d.value && d.value.tracks) {
              const filteredItems = d.value.tracks.items
                .filter(item => {
                  return item.artists.some(artist => {
                    return artist.name === this.artists[index][0].name;
                  });
                })
                .map(track => {
                  track.event = this.artists[index][0].event;
                  return track;
                });
              tracks.push({
                tracks: filteredItems
              });
            }
          });

          const sortedData = sortArrAsc(
            flattenArrayOfObjects(tracks, "tracks"),
            "popularity",
            "num",
            false
          );

          const filteredSortedData = sortedData.filter(track => {
            return track.event !== undefined;
          });

          this.sortedTracks = removeDuplicatesArrObj(
            filteredSortedData,
            "id",
            true
          );

          this.mapMarkers = this.events.map(event => {
            return {
              lat: event.location.geo.latitude,
              lng: event.location.geo.longitude,
              title: `<div><strong><a href="${event.url} target="_blank">${
                event.name
              }</a></strong><br>${event.location},<br>${event.startDate}<br>
              ${event.location.address.addressLocality}</div>`,
              location: event.location.address.addressLocality
            };
          });
          this.topTracks = data.data;
          //this.inputedLocation = this.city;
          this.lat = lat;
          this.lng = lng;
        })
        .catch(e => {
          // this.showError = true;
        })
        .finally(() => {
          if (this.totalEvents + 25 < this.eventsPage * 25) {
            this.isLoading = false;
          }
          if (this.sortedTracks.length === 0) {
            this.showError = true;
          }
        });
    },

    fetchInputedTracks(city) {
      this.isLoading = true;
      this.eventsPage = 1;
      this.tracksPage = 0;
      this.sortedTracks = [];
      this.events = [];
      this.limit = 100;
      const location = city || this.inputedLocation;
      const url = `${baseUrl}topTracksMultiple/and~City:${location}?limit=1`;

      memoize(url, axios.get, [url])
        .then(res => {
          const city = res.data[0].City;
          this.city = city;
          this.lat = res.data[0].Lat;
          this.lng = res.data[0].Lng;
          this.fetchConcerts(this.lat, this.lng);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    fetchTracksFromCurrentGeolocation() {
      getGeolocation().then(data => {
        const lat = data.latitude;
        const lng = data.longitude;
        Object.assign(this, {
          geolocation: data,
          lat,
          lng,
          lat_lng: `${lat},${lng}`
        });
        const router = this.$router;
        this.callFetchConcerts(lat, lng);
      });
    },

    callFetchInputedTracks() {
      Object.assign(this, {
        showPlayer: false,
        isLoading: true,
        page: -100,
        sortedTracks: [],
        topTracks: [],
        limit: 0
      });
      const location = this.inputedLocation;

      location
        ? this.fetchInputedTracks(this.inputedLocation)
        : this.fetchTracksFromCurrentGeolocation();
    },

    callFetchConcerts(lat, lng) {
      this.inputedLocation = "";
      this.lat_lng = this.$router.currentRoute.params.lat_lng;
      let latForFetch = lat || this.lat_lng.split(",")[0];
      let lngForFetch = lng || this.lat_lng.split(",")[1];

      this.eventsPage = 0;
      this.topTracks = [];
      this.sortedTracks = [];
      this.events = [];
      this.limit = 100;
      const cDateSplit = this.currentDate.split("-");
      const fDateSplit = this.futureDate.split("-");
      this.cDate = `${cDateSplit[1]}-${cDateSplit[2]}-${cDateSplit[0]}`;
      this.fDate = `${fDateSplit[1]}-${fDateSplit[2]}-${fDateSplit[0]}`;
      this.fetchConcerts(latForFetch, lngForFetch);
    },

    getRelatedInfo(artist) {
      this.toggleInfoIsResolved();
      this.getInfo(artist);
    },

    getInfo(artist) {
      Object.assign(this, {
        showArtistEvents: true,
        artist,
        dataUrls: {
          bio: `https://ws.audioscrobbler.com/2.0/?method=artist.getinfo&api_key=1f91c93293d618de5c30f8cfe2e9f5e9&format=json&artist=${
            artist.name
          }`,
          artist: `https://api.spotify.com/v1/artists/${artist.id}`,
          related: `https://api.spotify.com/v1/artists/${
            artist.id
          }/related-artists`,
          topTracks: `https://api.spotify.com/v1/artists/${
            artist.id
          }/top-tracks?market=US&limit=10`
        }
      });
    },

    remove: function(index) {
      this.sortedTracks.splice(index, 1);
    },

    toggleMap() {
      this.toggleProperty(this.showMap, "showMap");
      this.showInfoPlayer = false;
    },

    toggleProperty: function(isTrue, property) {
      this[property] = !isTrue;
    },

    toggleInfoIsResolved() {
      this.toggleProperty(this.infoIsResolved, "infoIsResolved");
    },

    closeInfo: function() {
      this.toggleProperty(this.showArtistEvents, "showArtistEvents");
      this.toggleInfoIsResolved();
      this.showInfoPlayer = false;
    },

    openMapModal(event = {}) {
      this.modalEvent = event;
      this.isModalOpen = true;
    },

    closeModal() {
      this.isModalOpen = false;
    },

    async setGenre(genre) {
      // resets base settings
      this.eventsPage = 0;
      this.tracksPage = 0;
      this.topTracks = [];
      this.sortedTracks = [];
      this.limit = 100;
      const genreIsActive = genre && genre.genre.checkedState;
      this.clearGenres();
      if (!genreIsActive) {
        this.genreIcons = toggleGenre(genre);
      }

      const checkedGenres = getCheckedGenres();
      this.genreForTitle = getGenreTitles();

      this.showPlayer = false;

      this.genreForTitle = getGenreTitles();
      this.selectedGenres = `${checkedGenres
        .map(genre => genre.genre.genre)
        .join("*")}`;

      this.genres = checkedGenres.length ? checkedGenres[0].genre.genre : "";

      const lat_lng = this.$route.params.lat_lng;
      const lat = lat_lng.split(",")[0];
      const lng = lat_lng.split(",")[1];
      return this.fetchConcerts(lat, lng, this.eventsPage);
    },

    clearGenres() {
      Object.assign(this, {
        genreIcons: clearGenres(),
        selectedGenres: null,
        genres: ""
      });
    },

    setTypeaheadUrl() {
      const inputedLocation = this.inputedLocation.toUpperCase().split(",");
      this.typeaheadUrl =
        inputedLocation.length > 1
          ? `${baseUrl}geolocationMultiple/and~City:${inputedLocation[0].trim()}_(or~Region:${inputedLocation[1].trim()})_(or~RegionId:${inputedLocation[1].trim()})`
          : `${baseUrl}geolocationMultiple/and~City:${inputedLocation[0].trim()}`;
    }
  },

  computed: {
    numTracks() {
      return this.sortedTracks.length;
    }
  }
};

function formatDate(d) {
  const date = new Date(d);
  var options = {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true
  };
  // Format the date
  var formattedDate = date.toLocaleString("en-US", options);
  return formattedDate;
}
</script>

<style>
.events {
  text-align: left;
  position: absolute;
  top: 75px;
  width: calc(100% - 40px);
  z-index: 100;
  height: 100%;
  overflow: auto;
  background: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-top: 3px solid #c53526;
}

.events li {
  list-style: none;
}

.container {
  display: flex;
  margin: 0;
  justify-content: space-between;
}

.media-content {
  margin-left: 24px;
}

.dates input {
  margin-right: 16px;
}
</style>
